<template>
  <div>
    <div class="table-wrap">
      <el-table size="small" :data="workerlist" border style="width: 100%">
        <el-table-column type="index" label=""> </el-table-column>
        <el-table-column prop="username" label="用户名"> </el-table-column>
        <!-- <el-table-column prop="card_number" label="开户地址">
          </el-table-column> -->
        <!-- <el-table-column prop="orderNo" label="提现单号">
          </el-table-column> -->
        <el-table-column prop="money" label="余额"> </el-table-column>
        <el-table-column prop="status" label="审核状态">
          <template slot-scope="scope">
            <span style="color: cadetblue" v-if="scope.row.is_success == 0"
              >不可接单</span
            >
            <span style="color: green" v-else-if="scope.row.is_success == 1"
              >可接单</span
            >
            <span style="color: red" v-else>审核未通过</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="申请日期"> </el-table-column>
        <el-table-column prop="card_name" label="开户行"> </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <span
              style="color: #0f85f4; cursor: pointer;"
              @click="navchange(scope.row)"
              >审核</span
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!--分页-->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="getworker.page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="getworker.rows"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <!--审核-->
    <el-dialog title="审核" :visible.sync="dialogVisible" width="30%">
      <el-form :model="workerinfo" :rules="rules" ref="formName">
        <!-- <el-form-item label="技师id">
                <el-input v-model="workerinfo.user_id" :disable="true"></el-input>
            </el-form-item>
            <el-form-item label="提现卡id">
                <el-input v-model="workerinfo.card_id"></el-input>
            </el-form-item>
            <el-form-item label="提现单号" >
                <el-input v-model="workerinfo.orderNo" ></el-input>
            </el-form-item> -->
        <el-form-item label="是否允许" prop="is_success	">
          <el-radio v-model="workerinfo.is_success" label="1"
            >允许接单</el-radio
          >
          <el-radio v-model="workerinfo.is_success" label="2"
            >拒绝接单</el-radio
          >
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="changestatus">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";
export default {
  data() {
    return {
      rules: {
        status: [{ required: true, message: "请选择！", trigger: "blur" }]
      },
      workerinfo: {
        status: 0
      },
      dialogVisible: false,
      workerlist: [],
      getworker: {
        page: 1,
        rows: 10
      },
      total: 0
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
  },
  mounted() {
    console.log("1212", this.workerlist);
  },
  methods: {
    // 进入审核页面
    navchange(e) {
      console.log("技师审核", e);
      // workerinfoitem = e
      (this.workerinfo = e), (this.dialogVisible = true);
    },
    // 修改审核状态
    changestatus() {
      let that = this;
      this.$refs["formName"].validate(valid => {
        if (valid) {
          request
            ._post("/shop/waiter.user/waiterState", {
              user_id: that.workerinfo.user_id,
              is_success: that.workerinfo.is_success
            })
            .then(res => {
              if (res.code == 1) {
                that.$message({
                  type: "success",
                  message: res.msg
                });
              }
              that.getTableList();
            });
        } else {
          console.log("选择", that.workerinfo);
        }
      });

      this.dialogVisible = false;
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      this.getworker.page = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.getworker.rows = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let that = this;
      request._get("/shop/waiter.user/list", this.getworker).then(res => {
        console.log(res, 121);
        this.workerlist = res.data.data;
        this.total = res.data.total;
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/views/supplier/worker/index.vue